export const dashboard = {
  jobPostsSummary: {
    title: 'Laatste jobposts',
    link: 'Alle posts',
    error: 'Posts niet gevonden',
  },
  forumPostsSummary: {
    title: 'Laatste forumposts',
    link: 'Naar het forum',
    error: 'Forumposts niet gevonden',
  },
  charts: {
    labels: {
      copyright: 'Deel auteursrechten',
      currentQ: 'Lopend kwartaal (K{{ quarter }})',
      expired: 'Vervallen',
      notExpired: 'Niet vervallen',
      performance: 'Deel beroepsinkomen',
      previousQ: 'Vorige kwartalen',
    },
    overview: 'Overzicht facturen per status',
    overviewChart: 'Grafiek met overzicht facturen per status',
    totalBilledChart: 'Grafiek met een overzicht van facturen',
    totalBilled: 'Totaal gefactureerd',
    yearSelector: 'Jaar – {{title}}',
    summary: {
      total: 'Totaal',
      amountInvoices: 'Aantal facturen',
      value: 'Bedrag',
    },
    cta: {
      title: 'Maak je eerste factuur aan.',
      text: 'Vanaf je eerste factuur is uitbetaald kan je hier je statistieken zien.',
      createInvoice: 'Factuur aanmaken',
    },
  },
  error: {
    title: 'Fout bij het laden van je dashboard.',
  },
  frameworkAgreement: {
    alreadySigned: 'Je bent al akkoord gegaan met de algemene voorwaarden.',
    checkboxError: 'Ga akkoord met de algemene voorwaarden om aan de slag te gaan.',
    checkboxLabel: 'Ik ga akkoord met de algemene voorwaarden',
    subtitle: 'Geen kleine lettertjes, enkel duidelijke afspraken.',
    title: 'Lees de algemene voorwaarden',
  },
  outstandingInvoices: {
    title: 'Openstaande facturen',
    toReceive: 'Nog te ontvangen',
    expired: '{{amount}} vervallen',
    summary_one: '{{count}} factuur',
    summary_other: '{{count}} facturen',
    summaryWithExpired_one: '{{count}} factuur, waarvan {{expiredCount}} vervallen',
    summaryWithExpired_other: '{{count}} facturen, waarvan {{expiredCount}} vervallen',
    table: {
      invoice: 'Factuur',
      dueDate: 'Vervaldatum',
      amount: 'Bedrag',
    },
    viewAll: 'Bekijk alle openstaande facturen',
  },
  header: {
    actionBlock: {
      button: 'Factuur aanmaken',
      dropdown: {
        client: 'Klant aanmaken',
        creditnote: 'Creditnota aanmaken',
        quotation: 'Offerte aanmaken',
      },
    },
  },
  progression: {
    steps: {
      completed: 'Voltooid:',
      uncompleted: 'Nog te doen:',
      create: 'Creëer en activeer je account',
      iban: 'Link je IBAN aan je Creative Shelter-account',
      peppol: 'Activeer je Peppol-inbox',
      signAddendum2024: 'Onderteken het addendum aan je raamovereenkomst met Creative Shelter',
      signContract: 'Teken je raamovereenkomst',
      signContractModalTitle: 'Teken jouw Creative Shelter raamovereenkomst',
      vatRegulation: 'Duid je btw-status aan',
      createInvoice: {
        title: 'Verstuur je eerste factuur',
        text: 'Voltooi eerst de andere stappen',
      },
    },
    title: 'Aan de slag',
    subtitle_one: 'Nog {{count}} stap voor je je eerste factuur kan maken.',
    subtitle_other: 'Nog {{count}} stappen voor je je eerste factuur kan maken.',
    subtitle_zero: 'Je bent klaar om je eerste factuur te versturen!',
    progress: '{{completedSteps}} / {{totalSteps}} voltooid',
  },
  stats: {
    copyrightAverage: {
      label: 'Gemiddelde auteursrechten',
      tooltip:
        'Vierjaarlijks gemiddelde dat je ontving als auteursvergoeding, via Creative Shelter.<br>Ben je minder dan vier jaar actief, dan is dit het gemiddelde van de jaren dat je actief bent.<br>Waarom dit belangrijk is, <a href="https://www.creativeshelter.be/begroting-hervorming-van-auteursrecht/" target="_blank">lees je hier!</a>',
    },
    copyrightThisYear: {
      label: 'Auteursrechten {{year}}',
      tooltip:
        'Totaalbedrag auteursvergoeding van alle betaalde facturen dit jaar. <br>Alles over de jaarlijkse limiet van je auteursvergoeding kan je <a href="https://www.creativeshelter.be/begroting-hervorming-van-auteursrecht/" target="_blank">hier lezen</a>.',
    },
    invoicedSumThisYear: {
      label: 'Jouw totale inkomsten in {{year}}',
      tooltip: 'Totale bedrag dat jij dit jaar hebt gefactureerd op ons platform.',
    },
    error: {
      title: 'Fout bij het laden van je dashboard.',
    },
    title: 'Statistieken',
  },
};
